import React from 'react';
import { LayoutDashboard, Package, Users, Bell, Clock, LogOut, Settings, BarChart3 } from 'lucide-react';
type Page = 'dashboard' | 'products' | 'competitors' | 'alerts' | 'history' | 'reports';
interface SidebarProps {
  currentPage: Page;
  setPage: (page: Page) => void;
}
export function Sidebar({
  currentPage,
  setPage
}: SidebarProps) {
  const menuItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: LayoutDashboard
  }, {
    id: 'products',
    label: 'Produtos',
    icon: Package
  }, {
    id: 'competitors',
    label: 'Concorrentes',
    icon: Users
  }, {
    id: 'alerts',
    label: 'Alertas',
    icon: Bell
  }, {
    id: 'reports',
    label: 'Relatórios',
    icon: BarChart3
  }, {
    id: 'history',
    label: 'Histórico',
    icon: Clock
  }];
  return <aside className="w-64 bg-navy-900 text-white flex flex-col fixed h-full left-0 top-0 z-20 shadow-xl" data-id="element-282">
      <div className="h-16 flex items-center px-6 border-b border-navy-800" data-id="element-283">
        <div className="flex items-center space-x-2" data-id="element-284">
          <div className="h-8 w-8 bg-white rounded-lg flex items-center justify-center" data-id="element-285">
            <span className="text-navy-900 font-bold text-xl" data-id="element-286">P</span>
          </div>
          <span className="font-bold text-lg tracking-wide" data-id="element-287">Preço Justo</span>
        </div>
      </div>

      <nav className="flex-1 py-6 px-3 space-y-1" data-id="element-288">
        {menuItems.map(item => {
        const Icon = item.icon;
        const isActive = currentPage === item.id;
        return <button key={item.id} onClick={() => setPage(item.id as Page)} className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 group ${isActive ? 'bg-white/10 text-white shadow-lg border-l-4 border-white' : 'text-slate-300 hover:bg-white/5 hover:text-white'}`} data-id="element-289">
              <Icon className={`h-5 w-5 ${isActive ? 'text-white' : 'text-slate-400 group-hover:text-white'}`} data-id="element-290" />
              <span className="font-medium text-sm" data-id="element-291">{item.label}</span>
            </button>;
      })}
      </nav>

      <div className="p-4 border-t border-navy-800" data-id="element-292">
        <button className="w-full flex items-center space-x-3 px-4 py-3 text-slate-400 hover:text-white transition-colors rounded-lg hover:bg-white/5" data-id="element-293">
          <Settings className="h-5 w-5" data-id="element-294" />
          <span className="font-medium text-sm" data-id="element-295">Configurações</span>
        </button>
        <button className="w-full flex items-center space-x-3 px-4 py-3 text-slate-400 hover:text-white transition-colors rounded-lg hover:bg-white/5 mt-1" data-id="element-296">
          <LogOut className="h-5 w-5" data-id="element-297" />
          <span className="font-medium text-sm" data-id="element-298">Sair</span>
        </button>
      </div>
    </aside>;
}